import { createFileRoute, notFound } from '@tanstack/react-router';

import { recordSearch } from './-record-search';
import { lazyScreen } from '@/shared/screen';

// Padrões da onda 2 só em dev (P2): em produção a rota responde 404 e o chunk nem é pedido.
export const Route = createFileRoute('/dev/record')({
  validateSearch: recordSearch,
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound() é o contrato do TanStack Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-record-catalog'), 'RecordCatalog') : () => null,
});
